// ── Filter-specific constants ─────────────────────────────────────────────────

/**
 * Canonical filter identifiers used across the catalog domain.
 *
 * Single source of truth — import these instead of sprinkling string literals.
 * The same strings arrive from panelSettings (catalog_initial_filtering,
 * catalog_filters) so the CMS contract stays in sync.
 */
export const FILTER_IDS = /** @type {const} */ ({
  ROOMS:             'rooms',
  AREA:              'area',
  PRICE_RANGE:       'price_range',
  PRICE_INPUT:       'price_input',
  BUILDINGS:         'buildings',
  TIERS:             'tiers',
  UNIT_LEVELS:       'unit_levels',
  EXTERNAL_AREAS:    'external_areas',
  EXPOSITION:        'exposition',
  ADDITIONAL_AREAS:  'additional_areas',
  INSOLATION:        'insolation',
  EXPOSITION_SIDES:  'exposition_sides',
  UNIT_NAME_SEARCH:  'unit_name_search',
  STATUS:            'status',
  CATEGORY:          'category',
  COMPARE_AREA:      'compare_area',
})

/**
 * Default main-bar filter IDs — always shown in the top bar, cannot be CMS-disabled.
 */
export const BASE_MAIN_FILTER_IDS = [FILTER_IDS.ROOMS, FILTER_IDS.AREA, FILTER_IDS.PRICE_RANGE]

/**
 * Component types used by filter registry entries.
 * Centralised so consumers don't sprinkle string literals in switch/if blocks.
 */
export const COMPONENT_TYPES = /** @type {const} */ ({
  RANGE_SLIDER:  'RangeSlider',
  RANGE_INPUTS:  'RangeInputs',
  MULTI_SELECT:  'MultiSelect',
  TEXT_SEARCH:   'TextSearch',
})

/**
 * Valid options for the unit_levels filter.
 * Exported so buildInitialFilters can use the same values for the default config.
 */
export const UNIT_LEVELS = /** @type {const} */ ({
  SINGLE: 'single',
  MULTI:  'multi',
})

/**
 * Slider step sizes for range filters.
 * Single source of truth — consumed by:
 *  - registry entry.step  (apply uses `this.step`)
 *  - buildInitialFilters  (rounding to step boundaries)
 *  - FilterInput           (passed as `step` prop to `<RangeSlider>`)
 */
export const RANGE_STEPS = /** @type {const} */ ({
  [FILTER_IDS.ROOMS]:       1,
  [FILTER_IDS.AREA]:        1,
  [FILTER_IDS.PRICE_RANGE]: 10_000,
})

/** Degrees for each named cardinal / intercardinal direction. */
export const DIRECTION_ANGLES = { N: 0, NE: 45, E: 90, SE: 135, S: 180, SW: 225, W: 270, NW: 315 }

/**
 * Canonical display order for exposition_sides option tags.
 * buildInitialFilters uses this to sort the option list; only present tags are included.
 */
export const EXPOSITION_SIDES_ORDER = ['corner', '1', '2', '3', '4+']